import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/ProduitReseauLc/';

export async function create(produitReseau) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', produitReseau);
  return response;
}

export async function update(produitReseau) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', produitReseau);
  return response;
}

export async function get(id, date) {
  const queryItems = {
    params: {
      Id: id,
      DateVisualisation: date,
    },
  };
  const response = await HTTP.get(URL_BASE + 'GetAsync', queryItems);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { id: id, archiver: status });
  return response;
}

export async function copieAsync(id, libelleCopiePrefixe) {
  const response = await HTTP.post(URL_BASE + 'CopieAsync', { id: id, libelleCopiePrefixe: libelleCopiePrefixe });
  return response;
}

export async function deleteReseau(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}
